
import {PublicKey} from "@solana/web3.js";

export const PROGRAM_ID: PublicKey = new PublicKey(
    'GGoMTmrJtapovtdjZLv1hdbgZeF4pj8ANWxRxewnZ35g'
);

export const BACKEND_URL = String(process.env.REACT_APP_BACKEND_URL);